// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation VoidJournalEntryMutation($input: VoidJournalEntryInput!) {
    voidJournalEntry(input: $input) {
      journalEntryEdge {
        node {
          id
          status
          voidedAt
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, { ...options });
  },
};
